
import axios from 'axios'
import config from '@/config'

const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

//Vue.prototype.$axios = axios//和export default axios一样

axios.defaults.timeout = 50000;
//xios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.post['Content-Type'] = 'application/json;';
//'application/json;charset=utf-8';//

axios.defaults.baseURL = baseUrl


axios.interceptors.request.use(config => {
    // 携带上token
    let token = $httpVue.$store.getters.getToken();
    token && (config.headers.Authorization = token);
    return config;
}, error => {
    return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
    //_showLoading && loading.close();
    //对响应数据做些事
    if (res.data.success) {
        return res;
    }
    return Promise.resolve(res);
}, (error) => {
    //_showLoading && loading.close();
    let httpMessage = '';
    if (error.response.data && error.response.data.message) {
        httpMessage = error.response.data.message;
    } else if (error.response.status == '404') {
        httpMessage = "没有找到请求的地址";
    } else {
        httpMessage = '网络好像出了点问题~'
    }

    //redirect(error.response, httpMessage);
    return Promise.reject(error.response);
});

function post(url, params) {
    //_showLoading = showLoading;
    //axios.defaults.headers[_Authorization] = getToken();
    return new Promise((resolve, reject) => {
        //  axios.post(url, qs.stringify(params))   //
        axios.post(url, params)
            .then(response => {
                // if (response.status == 202) {
                //     getNewToken(() => { post(url, params, _showLoading); });
                //     return;
                // }
                resolve(response.data);
            }, err => {
                // if (err.status == 202) {
                //     getNewToken(() => { post(url, params, _showLoading); });
                //     return;
                // }
                reject(err.data && err.data.message ? err.data.message : '网络好像出了点问题x!');
            })
            .catch((error) => {
                reject(error)
            })
    })
}

function del(url, params) {
    //_showLoading = showLoading;
    //axios.defaults.headers[_Authorization] = getToken();
    return new Promise((resolve, reject) => {
        //  axios.post(url, qs.stringify(params))   //
        axios.delete(url,{ data: params})
            .then(response => {
                // if (response.status == 202) {
                //     getNewToken(() => { post(url, params, _showLoading); });
                //     return;
                // }
                resolve(response.data);
            }, err => {
                // if (err.status == 202) {
                //     getNewToken(() => { post(url, params, _showLoading); });
                //     return;
                // }
                reject(err.data && err.data.message ? err.data.message : '网络好像出了点问题!');
            })
            .catch((error) => {
                reject(error)
            })
    })
}

function put(url, params) {
    //_showLoading = showLoading;
    //axios.defaults.headers[_Authorization] = getToken();
    return new Promise((resolve, reject) => {
        //  axios.post(url, qs.stringify(params))   //
        axios.put(url, params)
            .then(response => {
                // if (response.status == 202) {
                //     getNewToken(() => { post(url, params, _showLoading); });
                //     return;
                // }
                resolve(response.data);
            }, err => {
                // if (err.status == 202) {
                //     getNewToken(() => { post(url, params, _showLoading); });
                //     return;
                // }
                reject(err.data && err.data.message ? err.data.message : '网络好像出了点问题!');
            })
            .catch((error) => {
                reject(error)
            })
    })
}

 //_showLoading=true异步请求时会显示遮罩层,_showLoading=字符串，异步请求时遮罩层显示当前字符串
function get(url, param) {
    //_showLoading = showLoading;
   // axios.defaults.headers[_Authorization] = getToken();
    return new Promise((resolve, reject) => {
        axios.get(url, { params: param })
            .then(response => {
                console.log(response)
                // if (response.status == 202) {
                //     getNewToken(() => { get(url, param, _showLoading); });
                //     return;
                // }
                resolve(response.data)
            }, err => {
                // if (err.status == 202) {
                //     getNewToken(() => { get(url, param, _showLoading); });
                //     return;
                // }
                
               if (err.status  == 401) {
                  console.log(err)
                  $httpVue.$Message.error(err.data.msg);
                  $httpVue.$router.push({ path: '/login', params: { r: Math.random() } });
                }
               // reject(err)
            })
            .catch((error) => {
                console.log(error)
                //$httpVue.$Message.success('这是一条成功消息');
                
                reject(error)
            })
    })
}



let $httpVue = null;

function init(vue) {
    console.log("进入这http")
    $httpVue = vue;

    //console.log("token:"+$httpVue.$store.getters.getToken())
}
export default { post, get,del,put,init } 


// WEBPACK FOOTER //
// ./src/api/http.js